if (!window.__swatchTooltipInit) {
  window.__swatchTooltipInit = true;

  var activeTooltips = new Set();

  function getLabelFromTarget(target) {
    if (!target || !target.closest) return null;
    var label = target.closest('.swatch-scroll-wrapper [data-tooltip]');
    if (label) return label;
    if (target.tagName === 'INPUT' && target.id) {
      var selector = 'label[for="' + (window.CSS && CSS.escape ? CSS.escape(target.id) : target.id) + '"][data-tooltip]';
      var associated = document.querySelector(selector);
      if (associated && associated.closest('.swatch-scroll-wrapper')) return associated;
    }
    return null;
  }

  function showTooltip(label) {
    var tooltip = label.querySelector('.tooltip');
    if (!tooltip) return;
    var gap = 15;
    tooltip.style.position = 'fixed';
    tooltip.style.insetBlockEnd = 'auto';
    tooltip.style.insetInlineStart = '50%';
    tooltip.style.left = '0px';
    tooltip.style.top = '0px';
    tooltip.style.transform = 'translate(var(--translate-x), var(--translate-y)) scale(var(--scale))';
    var rect = label.getBoundingClientRect();
    var left = rect.left + rect.width / 2;
    var top = rect.top - tooltip.offsetHeight - gap;
    var parent = tooltip.offsetParent;
    if (parent) {
      var parentRect = parent.getBoundingClientRect();
      left -= parentRect.left;
      top -= parentRect.top;
    }
    tooltip.style.left = left + 'px';
    tooltip.style.top = top + 'px';
    activeTooltips.add(tooltip);
  }

  function hideTooltip(label) {
    var tooltip = label.querySelector('.tooltip');
    if (!tooltip) return;
    activeTooltips.delete(tooltip);
    var cleaned = false;
    var cleanup = function () {
      if (cleaned) return;
      cleaned = true;
      tooltip.removeAttribute('style');
      tooltip.removeEventListener('transitionend', cleanup);
    };
    tooltip.addEventListener('transitionend', cleanup);
    setTimeout(cleanup, 400);
  }

  document.addEventListener('mouseenter', function (e) {
    var label = getLabelFromTarget(e.target);
    if (label) showTooltip(label);
  }, true);

  document.addEventListener('mouseleave', function (e) {
    var label = getLabelFromTarget(e.target);
    if (label) hideTooltip(label);
  }, true);

  document.addEventListener('focusin', function (e) {
    var label = getLabelFromTarget(e.target);
    if (label) showTooltip(label);
  });

  document.addEventListener('focusout', function (e) {
    var label = getLabelFromTarget(e.target);
    if (label) hideTooltip(label);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || activeTooltips.size === 0) return;
    activeTooltips.forEach(function (tooltip) {
      tooltip.removeAttribute('style');
    });
    activeTooltips.clear();
  });
}
